import {Grid, Slot, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {toHeader} from '@yandex-delivery/order-form/src/widgets/Offers/Offers@desktop.utils'

import {Body} from '../../components/Body/Body'
import {filterWidgetsById, findWidgetById} from '../../lib/findWidget'
import {renderWidget} from '../../widgets/index@desktop'
import type {SectionProps as Props} from '../types'
import * as classes from './Offers@desktop.classes'

export const Offers: React.FC<Props> = props => {
  const {widgets} = props.section
  const headerWidget = findWidgetById(widgets, OFFERS_HEADER_WIDGET_ID)
  const dueSwitch = findWidgetById(widgets, DUE_SWITCH_WIDGET_ID)
  const dueSettings = filterWidgetsById(widgets, [DUE_DATE_WIDGET_ID, DUE_TIME_WIDGET_ID])
  const rest = filterWidgetsById(widgets, IDENTIFIED_WIDGETS_IDS, false)

  return (
    <Grid xs={12} item>
      <Paper padding="none" radius="L">
        <Body
          className={classes.offersBody}
          lead={headerWidget && renderWidget(toHeader(headerWidget))}
          tail={
            <>
              <div className={classes.dueSwitch}>
                {dueSwitch && renderWidget(dueSwitch)}
                {!dueSwitch && <Slot size="l" />}
              </div>

              {dueSettings.length !== 0 && <div className={classes.dueSettings}>{dueSettings.map(renderWidget)}</div>}
              {rest.map(renderWidget)}
            </>
          }
        />
      </Paper>
    </Grid>
  )
}

const DUE_TIME_WIDGET_ID = 'cargo_c2c_order_forms_b2b_lk_cargo_due_date_time_dropdown_list_widget::time_dropdown_list'
const DUE_DATE_WIDGET_ID = 'cargo_c2c_order_forms_b2b_lk_cargo_due_date_time_dropdown_list_widget::date_dropdown_list'
const DUE_SWITCH_WIDGET_ID = 'cargo_due_switch_widget'
const OFFERS_HEADER_WIDGET_ID = 'cargo_c2c_order_forms_b2b_lk_cargo_offers_section_header'
const IDENTIFIED_WIDGETS_IDS = [OFFERS_HEADER_WIDGET_ID, DUE_SWITCH_WIDGET_ID, DUE_DATE_WIDGET_ID, DUE_TIME_WIDGET_ID]
